import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Landing from "./pages/Landing";
import AuthCallback from "./pages/AuthCallback";
import Dashboard from "./pages/Dashboard";
import Championships from "./pages/Championships";
import ChampionshipDetail from "./pages/ChampionshipDetail";
import Pilots from "./pages/Pilots";
import PublicStandings from "./pages/PublicStandings";
import Manual from "./pages/Manual";
import Admin from "./pages/Admin";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import ProtectedRoute from "./components/ProtectedRoute";
import "./App.css";

function AppRouter() {
  const location = useLocation();
  
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  // Check URL fragment for session_id synchronously during render
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/forgot-password" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/clasificacion/:championshipId" element={<PublicStandings />} />
      <Route path="/dashboard" element={
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
      } />
      <Route path="/campeonatos" element={
        <ProtectedRoute>
          <Championships />
        </ProtectedRoute>
      } />
      <Route path="/campeonatos/:championshipId" element={
        <ProtectedRoute>
          <ChampionshipDetail />
        </ProtectedRoute>
      } />
      <Route path="/pilotos" element={
        <ProtectedRoute>
          <Pilots />
        </ProtectedRoute>
      } />
      <Route path="/manual" element={
        <ProtectedRoute>
          <Manual />
        </ProtectedRoute>
      } />
      <Route path="/admin" element={
        <ProtectedRoute>
          <Admin />
        </ProtectedRoute>
      } />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AppRouter />
      <Toaster position="top-right" richColors />
    </BrowserRouter>
  );
}

export default App;
